import { EventEmitter } from 'ahooks/lib/useEventEmitter';

enum MicroActType {
    CREATE_SUCCESS = 'create', // 子应用创建成功
    BEFORE_MOUNT = 'beforeMount', // 子应用挂载前
    AFTER_MOUNT = 'afterMount', // 子应用挂载后
    UN_MOUNT = 'unMount', // 子应用卸载
    ON_MOUNT_ERROR = 'mountError', // 子应用挂载失败
    INIT = 'init',
    DESTROY = 'destroy',
    UPDATE_DATA = 'updateData',
    FIRST_INIT = 'firstInit',
    UPDATE_DATA_BY_EVENT = 'updateDataByEvent',
}
interface IPageInfo {
    isLoading: boolean;
    data: any; // 跨页面数据类型不确定
    id: string; // 页面id 唯一标识
}
interface IMicroAppContainerProps {
    className?: string;
    style?: React.CSSProperties;
    microAppProps: {
        name: string;
        url: string;
        props?: any;
    };
    isFirstInit?: boolean;
    info?: Object; // 传递给子应用的数据
    loadElement?: JSX.Element | string | React.ReactNode;
    onCommunication?: (act: MicroActType, data?: Object) => Promise<Object>;
}

enum MICRO_PAGE_EVENT_TYPE {
    UPDATE_DATA_TO_PARENT = 'updateDataToParent', // 更新父页面数据
    UPDATE_DATA_TO_CHILD = 'updateDataToChild', // 更新子页面数据
}
interface IMicroPageEventInfo {
    type: MICRO_PAGE_EVENT_TYPE;
    data?: Record<string, any>;
}
interface IMicroAppBasicProps<T> {
    pageId?: string;
    globalEvent?: EventEmitter<IMicroPageEventInfo>;
    onCommunication?: (data: Record<string, string>, callBack?: VoidFunction) => T | void;
}
interface IMicroAppComponentsProps {
    name: string;
    renderContent: (props?: IPageInfo) => React.ReactNode;
}
export {
    IPageInfo,
    MicroActType,
    IMicroAppComponentsProps,
    MICRO_PAGE_EVENT_TYPE,
    IMicroPageEventInfo,
    IMicroAppBasicProps,
    IMicroAppContainerProps,
};
